import { ReactComponent as BillIcon } from "../../../assets/icons/bill.svg";
import DashboardCard from "../../../components/ui/dashboard/DashboardCard";
import { formatCurrencyForTable } from "../../../lib/utils";
import { useGetCompanyStatsQuery } from "../companyApiSlice";

const ExpenseDashCardView = () => {
  const { data, isLoading } = useGetCompanyStatsQuery();

  const companyStat = data?.data ?? {
    totalCount: 0,
    activeCount: 0,
    inActiveCount: 0,
  };

  const cards = [
    {
      label: "Total company",
      value: `${formatCurrencyForTable(companyStat.totalCount)}`,
    },
    {
      label: "Active company",
      value: `${formatCurrencyForTable(companyStat.activeCount)}`,
    },
    {
      label: "Inactive company",
      value: `${formatCurrencyForTable(companyStat.inActiveCount)}`,
    },
  ];

  return (
    <div className="flex flex-wrap gap-x-4 gap-y-4 sm:gap-x-10 sm:gap-y-6 bg-white rounded-[10px] p-4">
      {cards.map(({ label, value }) => (
        <DashboardCard
          key={label}
          icon={<BillIcon className="h-[31.7px] w-[31.7px]" />}
          value={isLoading ? "0" : value}
          label={label}
          iconClassName="bg-[#E7F2F5]"
        />
      ))}
    </div>
  );
};

export default ExpenseDashCardView;
